<template>
  <div  v-loading="loading">
    <Header></Header>
    <div class="home-body">
      <div class="home-main-container">
        <div class="home-main-box">
          <el-row>
            <el-col class="el-col-left">
              <div class="home-user-info">
                <div class="home-user-info-userEmail">{{ userEmail }}</div>
                <div class="home-user-info-petLength">
                  <span class="pet">Pet</span>{{ petsList.length }}
                </div>
              </div>
              <ul class="home-pet-info">
                <li
                  v-for="(item, index) in petsList"
                  :key="item.id"
                  @click="clickFlag ? getCurrentPetInfo(item, index) : leaveTab()"
                  :class="[
                  index === 0 ? dafaultPetStyle : '',
                  currentPetIndex === index ? currentPetStyle : '',
                ]"
                >
                  <span class="long-home-pet">{{
                  item.pet_name
                    .trim()
                    .replace(item.pet_name[0], item.pet_name[0].toUpperCase())
                }}</span>'s Information
                </li>
              </ul>

            </el-col>

            <span
              class="el-icon-back home-logout"
              @click="logOut"
            >
              <svg
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19 12.4001L5.00003 12.4001"
                  stroke="#999999"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12 19.4L5.00003 12.4L12 5.39996"
                  stroke="#999999"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <span class="home-logout-text">Log Out</span>
            </span>
            <div  v-if="this.showWaitPetsContent == false">
            <el-col class="el-col-right">
              <router-view
                v-if="this.petsList.length != 0"
                :currentPetInfo="currentPetInfo"
                :countryList="countryList"
                :petsBreeds="petsBreeds"
                @getPetInfo="getPetInfo"
                @getPetInfoCountry="getPetInfoCountry"
                @getPetInfoBreeds="getPetInfoBreeds"
              />
            </el-col>
            <div class="pw-index-no-pets" v-if="this.petsList.length == 0">
                Please scan the code and bind pet information first !
              </div>
            </div>
            <div class="pw-index-wait-pets" v-if="this.showWaitPetsContent == true"></div>
          </el-row>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../components/children/Header.vue";
import Footer from "../components/children/Footer.vue";
import { mapState } from "vuex";
export default {
  name: "Home",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      //加载状态
      loading:true,
      // 宠物数据
      petsList: [],
      // 是否存在宠物等待页面
      showWaitPetsContent:true,
      // 国家数据
      countryList: [],
      // 宠物种类数据
      petsBreeds: [],
      // 用户邮箱信息
      userEmail: "",
      // 选中的宠物信息
      currentPetInfo: {},
      // 选中的宠物index
      currentPetIndex: 0,
      // 选中的宠物样式
      currentPetStyle: {
        selectbc: false,
      },
      // 默认的宠物样式
      dafaultPetStyle: {
        selectbc: true,
      },
      userId: "",
      minHeight: 0,
    };
  },
  created() {
    // 获取用户Email信息
    this.userEmail = window.sessionStorage.getItem("usereamil");
    // 获取用户ID
    this.userId = window.sessionStorage.getItem("userid");
  },
  mounted() {
    // 获取宠物信息
    this.getPetInfo();
    // 获取国家信息
    this.getPetInfoCountry();
    // 获取宠物种类信息
    this.getPetInfoBreeds();
    //获取高度
    this.minHeight = document.documentElement.clientHeight - 160;
    var that = this;
    window.onresize = function () {
      that.minHeight = document.documentElement.clientHeight - 160;
    };
  },
  computed: {
    ...mapState("pcPetStore", ["clickFlag", "editPetState"]),
  },
  methods: {
    // 获取宠物列表
    async getPetInfo(info) {
      const { data: res } = await this.$http.get("/pets");
      if (res.status !== 200) return;
      this.petsList = res.data;
      this.showWaitPetsContent = false;
      // 默认初始化第一个宠物信息
      if (info) {
        this.currentPetInfo = info;
      } else {
        this.currentPetInfo = this.petsList[0];
        this.currentPetIndex = 0;
      }
      if (res.data.length === 0) {
        this.currentPetInfo = {};
      }
      this.loading = false;
    },
    //获取国家列表
    async getPetInfoCountry() {
      const { data: res } = await this.$http.get("/countrys");
      if (res.status !== 200) return;
      this.countryList = res.data;
    },
    //获取宠物种类信息
    async getPetInfoBreeds() {
      const { data: res } = await this.$http.get("/breeds");
      if (res.status !== 200) return;
      this.petsBreeds = res.data;
    },
    // 退出
    logOut() {
      //清空token
      sessionStorage.clear();
      location.href = "https://pawaiipets.com/pet-finder";
      // this.$router.push({
      //   path: "/login",
      // });
    },
    // 当前选择的宠物
    getCurrentPetInfo(item, index) {
      this.currentPetInfo = item;
      this.currentPetIndex = index;
      this.dafaultPetStyle.selectbc = false;
      this.currentPetStyle.selectbc = true;
    },
    // 表单未更改进行离开时提示
    leaveTab() {
      this.$message({
        type: "warning",
        message: "Switch the page after you saved the infomation",
      });
    },
  },
};
</script>

<style scoped>
.home-body {
  min-height: calc(100vh - 81px);
  padding-top: 121px;
}
.home-logout {
  cursor: pointer;
}
.el-col-right >>> .el-tabs--border-card {
  border-left: 1px solid #e5e5e5;
}
.long-home-pet {
  width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: right;
}
.home-main-container {
  width: 1002px;
  margin: 0 auto;
  border: 1px solid #e5e5e5;
  margin-bottom: 140px;
}
.el-form >>> .el-tabs--border-card >>> .el-tabs__header {
  display: none !important;
}
.el-col-left {
  position: relative;
  width: 300px;
}
.el-col-right {
  width: 700px;
}
.home-user-info-userEmail {
  font-family: Poppins-Medium;
  font-size: 18px;
  font-weight: 500;
  line-height: 25px;
  text-align: center;
  margin-top: 35px;
}
.home-user-info-petLength {
  font-family: Poppins-SemiBold;
  font-size: 18px;
  font-weight: 600;
  line-height: 25px;
  text-align: center;
  margin-top: 13px;
  margin-bottom: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.home-user-info-petLength span {
  display: block;
}
.home-user-info-petLength .pet {
  font-family: Poppins-SemiBold;
  font-size: 15px;
  font-weight: 300;
  line-height: 21px;
  margin-right: 18px;
  color: #999999;
}
.home-pet-info li:nth-child(1) {
  border-top: 1px solid #e5e5e5;
}
.home-pet-info li {
  padding-left: 15px;
  padding-right: 15px;
  height: 60px;
  color: #333333;
  border-bottom: 1px solid #e5e5e5;
  font-family: Poppins-Regular;
  font-size: 18px;
  font-weight: 400;
  line-height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.home-pet-info .selectbc {
  background: #ff5349;
  color: #ffffff;
  font-family: Poppins-Medium;
  font-size: 18px;
  font-weight: 500;
  line-height: 25px;
}
.home-pet-info li:hover {
  cursor: pointer;
}
.home-logout {
  position: absolute;
  left: 16px;
  bottom: 9.5px;
  font-family: Poppins-Regular;
  font-size: 15px;
  font-weight: 400;
  line-height: 21px;
  color: #999999;
}
.paw-petinfo-content >>> .el-tabs__header {
  display: none;
}
.home-main-box {
  min-height: auto;
}
.el-icon-back.home-logout {
  bottom: 20px;
  left: 10px;
  display: flex;
  align-content: center;
  justify-content: center;
}
.el-icon-back:before {
  display: none;
}
.el-icon-back svg {
  width: 24px;
  height: 24px;
  display: block;
  margin-right: 10px;
}
.home-logout-text {
  display: block;
}
.pw-index-no-pets{
  height:900px;
  display: flex;
  justify-content: center;
  align-content: center;
  border-left:0.5px solid #e2e2ee;
  padding-top:450px;
}
.pw-index-wait-pets{
  height:900px;
  border-left:0.5px solid #e2e2ee;
}
@media screen and (min-width: 768px) and (max-width: 1069px) {
  .home-body {
    min-height: calc(100vh - 84px);
    padding-top: 108px;
  }
  .home-main-container {
    width: calc(100vw - 68px);
    margin: 0 auto;
    margin-bottom: 85px;
  }
  .el-col-left {
    width: 250px;
  }
  .home-user-info-userEmail {
    margin-top: 52px;
  }
  .home-pet-info li {
    font-size: 15px;
    line-height: 21px;
  }
  .home-pet-info .selectbc {
    font-size: 15px;
    line-height: 21px;
  }
  .home-logout {
    left: 23px;
    bottom: 20.5px;
  }
  .el-col-right {
    width: calc(100% - 250px);
  }
}
@media screen and (width: 1024px) {
  .home-body {
    min-height: calc(100vh - 220px);
  }
}
</style>
